import React, { useEffect } from "react"
import { useValidatorSeeker } from "@app"
import { NumberFieldSeeker } from "@ui-seeker/core"
import { object, string } from "yup"

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { dsColorNew } from "@palette"


export default function AlertsComparatorValue() {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().comparatorValue || 0)

	const { errors, isValid } = useValidatorSeeker({ comparatorValue: dataInfo.value }, object({
		comparatorValue: string().test('comparator', 'Please provide a number between 1 and 10', c => c > 0 && c <= 10 && c[0] !== "0")
	}))

	useEffect(() => {
		alertsDrawerErrors.value = { ...alertsDrawerErrors.peek(), comparatorValue: isValid }
	}, [JSON.stringify(errors)])

	return <NumberFieldSeeker
		startIcon="star"
		startIconProps={{
			sx: {
				color: dsColorNew.noteAmber,
				mb: .3
			},
		}}
		label="Value"
		placeholder="Value to compare"
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'comparatorValue')}
		error={errors.comparatorValue}
	/>
}